import image5 from "../assets/Mockup_wrap.png";
import image5_mobile from "../assets/mockup_wrap.svg";
import image4 from "../assets/bell.svg";
import image3 from "../assets/chart_breakout_square.svg";
import image2 from "../assets/layers-three.svg";
import image1 from "../assets/speedometer-04.svg";
import hand_arrow from "../assets/hand_arrow.svg";

export default function Page7() {
  return (
    <div className="page7_main_div_new">
      <div className="page7_sub_div_new">
        <h5>Features</h5>
        <h1>What You Get</h1>
        <p>
          Discover a suite of powerful tools built to simplify simulator
          management, enhance training efficiency, and keep operations running
          smoothly.
        </p>
      </div>

      <div className="d-flex flex-column flex-md-row justify-content-center align-items-center  pt-5 page7_sub2_div_new">
        <div className="row page7_sub_div_new_card_main_div pe-0 pe-lg-5 flex-wrap w-1/2">
          <div className=" col-12 col-md-6 page7_card_div">
            <div className="outer-circle">
              <div className="page7_new_container_andromeda">
                <img
                  src={image1}
                  className="img-fluid"
                  width={24}
                  height={24}
                  alt="Andromeda"
                />
              </div>
            </div>

            <h4>Performance Dashboard</h4>
            <p>
              Track simulator health at a glance with live metrics and instant alerts for anomalies.
            </p>
          </div>

          <div className=" col-12 col-md-6 page7_card_div">
            <div className="outer-circle">
              <div className="page7_new_container_andromeda">
                <img
                  src={image2}
                  className="img-fluid"
                  width={24}
                  height={24}
                  alt="Andromeda"
                />
              </div>
            </div>
            <h4>Maintenance Logs</h4>
            <p>
              Keep all inspections, repairs, and service reports securely logged for easy reference.
            </p>
          </div>

          <div className=" col-12 col-md-6 page7_card_div">
            <div className="outer-circle">
              <div className="page7_new_container_andromeda">
                <img
                  src={image3}
                  className="img-fluid"
                  width={24}
                  height={24}
                  alt="Andromeda"
                />
              </div>
            </div>
            <h4>Analytics & Reports</h4>
            <p>
              Identify training patterns and optimize efficiency with detailed analytics and benchmarking.
            </p>
          </div>

          <div className=" col-12 col-md-6 page7_card_div">
            <div className="outer-circle">
              <div className="page7_new_container_andromeda">
                <img
                  src={image4}
                  className="img-fluid"
                  width={24}
                  height={24}
                  alt="Andromeda"
                />
              </div>
            </div>
            <h4>Custom Notifications</h4>
            <p>
              Stay informed anywhere, anytime with instant notifications for urgent events or performance drops.
            </p>
          </div>
        </div>

        <div className="d-none d-lg-block  img_div_neww w-1/2">

            <div className="hand_arrow_img_class">        <img
            src={hand_arrow}
            className=""
            alt="Aviation academies"
          /></div>


          <img
            src={image5}
            className=" "
            alt="Aviation academies"
          />
        </div>


                <div className="d-block d-lg-none  pt-5 img_div_neww_mobile w-full">


          <img
            src={image5_mobile}
            className=" "
            alt="Aviation academies"
          />
        </div>
      </div>
    </div>
  );
}
